@if (assetsReady) {
  <div class="container" [class.mobile]="isMobileVersion">
    @if (!isMobileVersion) {
      <div class="illustration">
        @if (illustration) {
          <img [src]="illustration" />
        } @else {
          <ng-content select="[illustration]"></ng-content>
        }
      </div>
    }
    <div class="controls">
      <img [src]="logo" (click)="onLogoClick()" />
      @if (showForgotPasswordView) {
        <ng-content select="[forgot-password]"></ng-content>
      } @else {
        <abc-authentication-login
          #abcLoginComponent
          [hidden]="needsPasswordChange"
          (onNeedsPasswordChange)="onNeedsPasswordChange()"
          (onForgotPasswordClicked)="showForgotPasswordView = true"
          [showRegistration]="showRegistration"
          [showResetPassword]="showResetPassword"
          [useCustomLoader]="useCustomLoader"
          [twoFaIssuer]="twoFaIssuer"
        >
          <ng-content custom-loader select="[custom-loader]"></ng-content>
        </abc-authentication-login>

        @if (needsPasswordChange) {
          <abc-management-users-user-settings
            [allowUserNameChange]="false"
            [useLocalPasswordChangeModel]="true"
            (onPasswordChanged)="onPasswordChanged()"
          >
          </abc-management-users-user-settings>
        }
      }

      <div>
        <abc-setup-info></abc-setup-info>
      </div>
    </div>
  </div>
}
